import { useAuth0 } from '@auth0/auth0-react';
import { LoggedOutScreen } from '@strata/react-page-templates';

export const LoggedOut = () => {
    const { loginWithRedirect } = useAuth0();
    return (
        <LoggedOutScreen
            appName={LoggedOutScreen.Logos.STRATA}
            logInOnClick={() => {
                (() => loginWithRedirect())();
            }}
        />
    );
};
